/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect } from 'react';
import { AppBar, Box, Grid, Typography, Button, useMediaQuery } from '@material-ui/core';
import { globalizationPath, useGlobal } from '@rcg/ui-react';
import { useIdle } from 'react-use';
import { useApolloClient } from '@apollo/client';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import headerStyles from './index.style';
import Loader from '../Loader/index';
import { ReactComponent as Logo } from '../../assets/svg/logo.svg';
import { ReactComponent as RightArrow } from '../../assets/svg/right-arrow.svg';
import { sendTrackingParams } from '../../commons/tracking/tracking';
import { COOKIE_KEYS, NAVIGATION_PATHS, GA_PAGE } from '../../commons/constants';
import { getCookies, signOffProfile, cleanCookie, createCookie } from '../../commons/utils';
import { useGlobalLogin } from '../../providers/GlobalLoginProvider';
import Theme from '../../theme/booking-theme';
import { ReactComponent as LeftArrow } from '../../assets/svg/left-arrow.svg';

const Header = ({
  headerFunc,
  headerState,
  isLoggedIn,
  fixPosition,
  isProfileDataEmpty = true,
  guestName = null,
}) => {
  const classes = headerStyles();
  const GLOBALS = useGlobal();
  const { renderContent } = useGlobal();
  const { market, lang } = GLOBALS.data;
  const urlPath = globalizationPath(market, lang, '/');
  const client = useApolloClient();

  const isDesktop = useMediaQuery(Theme.breakpoints.up('md'));

  const getUserProfileName = (loyaltyData) => {
    const parts = loyaltyData?.split('|');
    const name = parts?.[0].split('=');
    return name?.[1];
  };

  const [showLoader, setShowLoader] = useState(false);
  const [profileName, setProfileName] = useState(null);

  const isLookUpPage = window.location.pathname.includes('lookup');

  const isIdle = useIdle(1.8e6); // 30 minutes track user inactivity

  const { isAuthenticated, revokeToken } = useGlobalLogin();
  const profile = getCookies(COOKIE_KEYS.ACCESS_TOKEN);
  const isGALoggedIn = (Boolean(profile) || isLoggedIn) && isAuthenticated;

  useEffect(() => {
    const loyaltyData = guestName || getCookies(COOKIE_KEYS.LOYALTY_DATA);
    const name = loyaltyData && getUserProfileName(loyaltyData);
    setProfileName(name);
  }, [guestName]);

  const signOut = async () => {
    setShowLoader(true);
    await sendTrackingParams(
      {
        eventType: 'interactions',
        interaction: `myres:lookup:signOut`,
      },
      false
    );

    setTimeout(async () => {
      await revokeToken();
      // Preserve cookies before redirect
      const manageVer = getCookies('manage_ver');
      const manageExperience = getCookies('manage_experience');
      const rwdId = getCookies('rwd_id');
    signOffProfile(client);
      if (!manageVer) {
        createCookie({ name: 'manage_ver', value: manageVer });
      }
      if (!manageExperience) {
        createCookie({ name: 'manage_experience', value:manageExperience});
      }
      if (!rwdId) {
        createCookie({ name: 'rwd_id', value: rwdId || rwdId });
      }

      window.location.replace(
        `${globalizationPath(market, lang, NAVIGATION_PATHS[0].reservation)}`
      );
    }, 1000); // wait until tracking params are sending before to dispath a redirection
  };

  useEffect(() => {
    if (isIdle) {
      signOut();
    }
  }, [isIdle]);
  const redirect = () => {
    cleanCookie(COOKIE_KEYS.KEEP_ALIVE);
    window.location.replace(`${globalizationPath(market, lang, NAVIGATION_PATHS[0].login)}`);
  };

  return (
    <>
      <AppBar
        className={classes.root}
        position="fixed"
        style={{ left: fixPosition ? '49.65%' : '50%' }}
      >
        <Grid container>
          <Grid item xs={isGALoggedIn && isLookUpPage ? 7 : 1} className="logo">
            <a href={urlPath}>
              <Logo className="logo__icon" />
            </a>
            {!isProfileDataEmpty && isGALoggedIn && isLookUpPage && (
              <Typography component="div">
                <a
                  role="button"
                  href=""
                  tabIndex={0}
                  onClick={redirect}
                  className={classes.backToReservationLink}
                >
                  <span>
                    <LeftArrow width={16} height="100%" />
                  </span>
                  {isDesktop ? (
                    <Typography component="span">
                      {renderContent(
                        'amendHeaderBackReservationCompleteLabel',
                        'Back to your cruise reservation'
                      )}
                    </Typography>
                  ) : (
                    <Typography component="span">
                      {renderContent('amendHeaderReservationLabel', 'Reservation')}
                    </Typography>
                  )}
                </a>
              </Typography>
            )}
          </Grid>

          {!isLookUpPage && (
            <Grid item xs={6}>
              <Box
                className="panel-toggler"
                data-testid="header"
                onClick={() => {
                  headerFunc({ isPanelOpen: !headerState.isPanelOpen });
                }}
              >
                <Typography className="panel-toggler__label" component="h4">
                  {renderContent('headerBookingAmendTitleLabel', 'View Itinerary')}
                </Typography>
                <RightArrow className="panel-toggler__icon" />
                {headerState.isPanelOpen && (
                  <Typography className="back__label">
                    {renderContent('headerBookingAmendBackLabel', 'Back')}
                  </Typography>
                )}
              </Box>
            </Grid>
          )}

          {!headerState.isPanelOpen && (
            <Grid item xs={5}>
              <Typography className="logout" data-testid="exit">
                {isGALoggedIn && profileName && (
                  <>
                    <a className="greetingLink" href={GA_PAGE}>
                      <span className="greetingHeader" data-cs-mask>
                        {profileName &&
                          `${renderContent('headerBookingAmendGreeting', 'Hi')}, ${profileName} `}
                        <span className="blankSpaceSpan" />|<span className="blankSpaceSpan" />
                      </span>
                    </a>
                    <Button variant="text" onClick={signOut}>
                      <span className="exit-label">
                        {renderContent('headerBookingAmendSignOut', 'Sign out')}
                      </span>
                      <ExitToAppIcon className="exit-icon" />
                    </Button>
                  </>
                )}
                {!isGALoggedIn && !isLookUpPage && (
                  <Button variant="text" onClick={signOut}>
                    {renderContent(`headerBookingAmendExitLabel`, `Exit`)}
                  </Button>
                )}
              </Typography>
            </Grid>
          )}
        </Grid>
      </AppBar>
      <Loader display={showLoader} />
    </>
  );
};

export default Header;
